// src/components/Layout/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import { HamburgerButton } from '../Navigation/HamburgerButton';
import { useGlobal } from '../../context/GlobalContext';
import './Header.css';

export function Header() {
  const { dispatch } = useGlobal();

  const toggleSidebar = () => {
    dispatch({ type: 'TOGGLE_SIDEBAR' });
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-left">
          <HamburgerButton onClick={toggleSidebar} />
          <Link to="/" className="logo">
            Supply Chain Brutus
          </Link>
        </div>
        <a 
          href="https://app.supplychainbrutus.com" 
          className="launch-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Launch App
        </a>
      </nav>
    </header>
  );
}